import { createFileRoute } from "@tanstack/react-router";

import AdminHubPage from "@/app/admin/AdminHubPage";

export const Route = createFileRoute("/admin/")({
  component: AdminHubPage,
});
